import { ITextureStyle } from "../../../../base/domain/drawing";
import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IFormatSpecification } from "../IFormatSpecification";
import { ITexturedShapeDrawableObject } from "../objects";
import { AbstractShapeDrawableObjectEditor } from "./AbstractShapeDrawableObjectEditor";
import { ITextureStylePropertyEditable } from "../properties";

export abstract class AbstractTexturedShapeDrawableObjectEditor<TObject extends ITexturedShapeDrawableObject> extends AbstractShapeDrawableObjectEditor<TObject> implements ITextureStylePropertyEditable {
  constructor(source: TObject | AbstractTexturedShapeDrawableObjectEditor<TObject>, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._textureStyle = this.createPropertyEditor(s => s.textureStyle, (s, v) => s.textureStyle = v);
  }

  protected _textureStyle: IPropertyEditable<ITextureStyle>;

  textureStyle(): IPropertyEditable<ITextureStyle> {
    return this._textureStyle;
  }
}
